
import React, { Component, Fragment } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

class Datatable_subcategory extends Component{

    constructor(props){
        super(props);
        this.state={
            myData: this.props.myData,
        }
    }

    selectRow = (e, i) => {
        if (!e.target.checked) {
            this.setState({
                checkedValues: this.props.checkedValues.filter((item, j) => i !== item)
            });
        } else {
            this.props.checkedValues.push(i);
            this.setState({
                checkedValues: this.props.checkedValues
            })
        }
    }

    handleRemoveRow = (e) => {
        const selectedValues = this.props.checkedValues;
        const updatedData = this.props.myData.filter(function (el) {
            return selectedValues.indexOf(el.id) < 0;
        });
        this.setState({
            myData: updatedData
        })
        toast.success("Successfully Deleted !")
    };

    renderEditable = (cellInfo) => {
        return (
            <div
                style={{ backgroundColor: "#fafafa" }}
                contentEditable
                suppressContentEditableWarning
                onBlur={e => {
                    const data = [...this.props.myData];
                    data[cellInfo.index][cellInfo.column.id] = e.target.innerHTML;
                    this.setState({ myData: data });
                }}
                dangerouslySetInnerHTML={{
                    // __html: this.props.myData[cellInfo.index][cellInfo.column.id]
                    __html: [cellInfo.original.id][0]
                }}
            />
        );
    }

    Capitalize(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
    deleteHandler = (id) => {
        const url = `${process.env['REACT_APP_HOST']}/api/categories/${id}`;
        const params = {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            }
        };
        fetch(url, params)
            .then(response => response.json())
            .then(data => {
            })
    }

    render() {
        const { pageSize, myClass, multiSelectOption, pagination } = this.props;
        const { myData } = this.props
        console.log(myData);
        const columns = [];
        for (var key in myData[0]) {

            let editable = this.renderEditable
         
            if (key === "_id") {
                editable = null;
            }
            if (key === "parentId") {
                editable = null;
            }
            if (key === "name") {
                editable = null;
            }
            if (key === "createdAt") {
                editable = null;
            }
            if (key === "updatedAt") {
                editable = null;
            }
            editable = null;
            if(["name"].includes(key)){
                columns.push(
                    {
                        Header: <b>{this.Capitalize(key.toString())}</b>,
                        accessor: key,
                        Cell: editable,
                        style: {
                            textAlign: 'center'
                        }
                    });
            }
            if(["Categoryname"].includes(key)){
                columns.push(
                    {
                        Header: <b>Category Name</b>,
                        accessor: key,
                        Cell: (row) => (row.original.Categoryname),
                        style: {
                            textAlign: 'center'
                        }
                    });
            }
            if(["Parentname"].includes(key)){
                columns.push(
                    {
                        Header: <b>Parent Category Name</b>,
                        accessor: key,
                        Cell: (row) => (row.original.Parentname),
                        style: {
                            textAlign: 'center'
                        }
                    });
            }
        }

        if (multiSelectOption == true) {
            columns.push(
                {
                    Header: <button className="btn btn-danger btn-sm btn-delete mb-0 b-r-4"
                        onClick={
                            (e) => {
                                if (window.confirm('Are you sure you wish to delete this item?'))
                                    this.handleRemoveRow(e)
                            }}>Delete</button>,
                    id: 'delete',
                    accessor: str => "delete",
                    sortable: false,
                    style: {
                        textAlign: 'center'
                    },
                    Cell: (row) => (
                        <div>
                            <span >
                                <input type="checkbox" name={row.original.id} defaultChecked={this.props.checkedValues.includes(row.original.id)}
                                    onChange={e => this.selectRow(e, row.original.id)} />
                            </span>
                        </div>
                    ),
                    accessor: key,
                    style: {
                        textAlign: 'center'
                    }
                }
            )
        } else {
            columns.push({
                Header: <b>Action</b>,
                id: 'delete',
                accessor: str => "delete",
                Cell: (row) => (
                    <div>
                        <span onClick={() => {
                            if (window.confirm('Are you sure you wish to delete this item?')) {
                                let data = myData;
                                data.splice(row.index, 1);
                                this.setState({ myData: data });
                                this.deleteHandler(row.original._id);
                                toast.success("Successfully Deleted !")
                            }
                        }}>
                            <i className="fa fa-trash" style={{ width: 35, fontSize: 20, padding: 11, color: '#e4566e' }}
                            ></i>
                        </span>
                        
                        <a href={`${process.env.PUBLIC_URL}/products/digital/edit-subcategory/${row.original._id}`}><i className="fa fa-pencil" style={{ width: 35, fontSize: 20, padding: 11,color:'rgb(40, 167, 69)' }}></i></a>
                        
                    </div>
                ),
                style: {
                    textAlign: 'center'
                },
                sortable: false
            }) 
        }
        
        return (
            <Fragment>
                <ReactTable
                    data={myData}
                    columns={columns}
                    defaultPageSize={pageSize}
                    className={myClass}
                    showPagination={pagination}
                />
                <ToastContainer />
            </Fragment>
        )
    }
    
}


export default Datatable_subcategory